import { createSlice } from '@reduxjs/toolkit';

import {
  repricerSettingsReducers,
  updateRepricerSettingsReducers,
  runRepricerReducers,
  resetCompletedListingsReducers,
  storeRepricerSettingsReducers,
  repricerListingsReducers,
  getListingRepricerDetailsReducers,
  bulkUpdateListingsReducers,
  updateListingRepricerReducers,
  getRepricerStatusCountsReducers,
  processStatusReducers,
} from './listing-repricer.reducers';

const initialState = {
  // Optimization settings
  settings: {
    schedule: [],
    maxListingsPerRun: 100,
    priorityCompetitors: [],
  },
  getRepricerSettingsStatus: 'idle',
  updateRepricerSettingsStatus: 'idle',

  // Optimization run
  isRepricerRunning: false,
  lastRepricerResult: null,
  runRepricerStatus: 'idle',
  resetCompletedListingsStatus: 'idle',

  // Store optimizer settings
  storeRepricerSettings: {
    minimumOverallMarkup: 0,
    marketplaceCommissionMarkup: 0,
  },
  getStoreRepricerSettingsStatus: 'idle',
  updateStoreRepricerSettingsStatus: 'idle',

  // Optimization listings
  listings: [],
  listingsTotalCount: 0,
  listingsCurrentPage: 1,
  listingsTotalPages: 1,
  getRepricerListingsStatus: 'idle',

  // Selected listing details for modal
  selectedListingDetails: null,
  getListingRepricerDetailsStatus: 'idle',

  // Update listing optimization
  updateListingRepricerStatus: 'idle',

  // Bulk update listings
  bulkUpdateStatus: 'idle',
  bulkUpdateResult: null,

  // Process status
  processStatusLoading: 'idle',
  processStatus: null,

  // Status counts
  statusCounts: {
    totalOptimized: 0,
    activeOptimizations: 0,
    inactiveOptimizations: 0,
    winningOptimizations: 0,
    readyForReview: 0,
  },
  getRepricerStatusCountsStatus: 'idle',

  // Error handling
  error: null,
};

const listingRepricerSlice = createSlice({
  name: 'listingRepricer',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearOptimizationResult: (state) => {
      state.lastRepricerResult = null;
    },
    setOptimizationRunning: (state, action) => {
      state.isRepricerRunning = action.payload;
    },
  },
  extraReducers: (builder) => {
    repricerSettingsReducers(builder);
    updateRepricerSettingsReducers(builder);
    runRepricerReducers(builder);
    resetCompletedListingsReducers(builder);
    storeRepricerSettingsReducers(builder);
    repricerListingsReducers(builder);
    getListingRepricerDetailsReducers(builder);
    bulkUpdateListingsReducers(builder);
    updateListingRepricerReducers(builder);
    getRepricerStatusCountsReducers(builder);
    processStatusReducers(builder);
  },
});

export const { clearError, clearOptimizationResult, setOptimizationRunning } =
  listingRepricerSlice.actions;

export default listingRepricerSlice.reducer;
